﻿import { Plugin } from 'ckeditor5';

class ClipboardCleanup extends Plugin {
    static get pluginName() { return "ClipboardCleanup" };

    init() {
        const editor = this.editor;

        //"RemoveFormat"-Plugin sadly does not remove styles from block elements(p-tags) yet, which results in problems that useres can not fix --> TechSupport Ticket 36463: (SST) - neuer CK-Editor
        if (editor.plugins.has('ClipboardPipeline')) {
            editor.plugins.get('ClipboardPipeline').on('inputTransformation', (evt, data) => {
                cleanupTags(data.content);
            });
        }
    }
}

function cleanupTags(content) {
    let tagsToRemove = [];

    for (let i = 0; i < content.childCount; i++) {
        let element = content.getChild(i);

        if (element.name === 'table' || element.name === 'td' || element.name === 'p') {
            element._attrs.clear();
            element._classes.clear();
        }

        if (element._styles) {
            element._styles.clear();

            if (element.name === 'table') {
                element._styles.set('width', '100%');
            }
        }

        if (element.childCount > 0) {
            cleanupTags(element);
        }
        if (element.name === 'img' || element.name === 'image') {
            tagsToRemove.push(i);
        }
    }


    if (tagsToRemove.length > 0) {
        for (let i = 0; i < tagsToRemove.length; i++) {
            content._removeChildren(i, 1)
        }
    }
}
export default ClipboardCleanup;